<template>
  <div
    class="browsing-tag"
    :class="{ 'is-selected': isSelected }"
    @click="clickTag(language.id)"
  >
    <div class="label">
      <div :class="{ 'is-underlined': isSelected }">{{ language.label }}</div>
      <div v-if="language.label === 'Other'" class="sublabel">{{ localizedOther }}</div>
      <div v-else class="sublabel">{{ language.localized_label }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LanguageTag",
  props: ["language", "onClick", "isSelected"],
  data: function () {
    return {
      userLanguage: "en",
      tags: [],
      localizedOther: "Other",
      translationArryOther: {
        en: "Other",
        ar: "آخر",
        zh: "其他",
        cs: "jiný",
        da: "Andet",
        nl: "Ander",
        fi: "Muut",
        fr: "Autre",
        de: "Andere",
        el: "Αλλα",
        hi: "अन्य",
        is: "Annað",
        it: "Altro",
        ja: "他の",
        ko: "다른",
        no: "Annen",
        pl: "Inny",
        pt: "Outro",
        pa: "ਹੋਰ",
        ru: "Другой",
        es: "Otro",
        sw: "Nyingine",
        sv: "Övrig",
        ur: "دیگر"
      },
    };
  },
  beforeMount() {
    if (this.language.label === 'Other') {
      let browserLanguage = navigator.languages[0].split("-")[0].toLocaleLowerCase()
      if (browserLanguage && browserLanguage in this.translationArryOther) {
        this.userLanguage = browserLanguage;
        this.localizedOther = this.translationArryOther[browserLanguage]
      }
    }
    
  },
  computed: {
    ...mapState({
      user: "user",
    })
  },
  methods: {
    clickTag(id) {
        this.onClick(id)
    },
  },
};
</script>

<style lang="scss" scoped>
.browsing-tag {
  display: flex;
  padding: 10px 18px 9px 18px;
  margin: 4px;
  border: 2px solid #f2ece3;
  border-radius: 20px;
  font-size: 13.5pt;
  font-weight: 500;
  font-family: $font-family;
  cursor: pointer;

  .icon {
    height: 32px;
    margin: -2px 8px 0 0;
  }

  .label{
    display: block;
    text-align: center;
  }
  .sublabel {
    opacity: 0.85;
    font-size: 11pt;
  }
}

.browsing-tag.is-selected {
  font-weight: 500;
  border: 2px solid darken(#f7af3c, 0%) !important;
}

.is-underlined {
  text-decoration: underline;
}

.browsing-tag:hover {
  border: 2px solid lighten(#f7af3c, 20%);
}

.tag-choices {
  display: flex;
  padding: 0px 0px 0px 0px;
  margin-left: 8px;
}

.sub-tag {
  display: inline-block;
  padding: 3px 9px 3px 9px;
  margin: 2px;
  border: 2px solid #f2ece3;
  border-radius: 10px;
  text-decoration:none;
  font-size: 11pt;
  font-weight: 500;
  font-family: $font-family;
  cursor: pointer;

  .icon {
    height: 22px;
    margin: -1px 2px -4px 0;
  }
}

.sub-tag.is-selected {
  font-weight: 500;
  text-decoration: underline;
  border: 2px solid darken(#f7af3c, 0%) !important;
}
.sub-tag:hover {
  border: 2px solid lighten(#f7af3c, 20%);
}

.disabled {
  background: #f4f4f4 !important;
  color: #aaa !important;
  pointer-events: none !important;
  
  .icon {
    background: #f4f4f4;
    border-radius: 60%;
    filter: grayscale(1);
  }
}

@media (max-width: 1024px) {
  .browsing-tag {
    padding: 6px 12px 6px 12px;
    font-size: 12pt;
  }
}
</style>
